<template>
    <div class="jump-order nav-bar-fixed">
        <van-nav-bar title="账单还款成功" left-arrow fixed  @click-left="back" />
        <van-row>
          <van-col span="4"></van-col>
          <van-col span="16">
              <div class="jump-order-body">
                <div class="jump-order-body-whd">
                    <van-icon name="success" />
                    <p>账单还款成功</p>
                </div>
                <div class="jump-order-body-foot">
                    <van-button size="large" url="#/home">继续逛逛</van-button>
                </div>
            </div>
          </van-col>
          <van-col span="4"></van-col>
        </van-row>
    </div>
</template>
<script>
import { NavBar,Button,Row,Col } from "vant";
export default {
  name: "ordersuccess",
  components: {
    [NavBar.name]: NavBar,
    [Button.name]:Button,
    [Row.name]:Row,
    [Col.name]:Col
  },
  data() {
    return {
      orderId:0,
      orderPrice:0,
      pointAmount:0
    };
  },
  methods: {
    back() {
      this.$router.push('/home');
    }
  },
  mounted(){
  }
};
</script>
<style lang="less" scoped>
@bule-thame: #3c6eeb;
body {
  background-color: #f7f7f7;
}
.jump-order {
  padding-top: 50px;

  &-body {
    padding-top: 100px;
    &-whd {
      text-align: center;
      i {
        color: #fff;
        border-color: #1989fa;
        background-color: #1989fa;
        border-radius: 100%;
        font-size: 56px;
      }
      p{
        padding: 20px 0;
      }
    }
    &-foot{
      p{
        padding-left: 15px;
        margin-bottom: 10px;
        span{
          color: red;
        }
      }
      button{
        background-color: @bule-thame;
        color: white;
        font-weight: 700;
        border-radius: 5px;
        margin: 25px 0 10px;
      }
    }
  }
}
</style>


